var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, } from 'react';
const Switch = forwardRef(function Switch(_a, ref) {
    var { className, hideLabel, id, label, labelClassName } = _a, props = __rest(_a, ["className", "hideLabel", "id", "label", "labelClassName"]);
    return (_jsxs("div", { className: classNames('form-check form-switch', className), children: [_jsx("input", Object.assign({ className: "form-check-input", id: id, ref: ref, role: "switch", type: "checkbox" }, props)), _jsx("label", { className: classNames('form-check-label', labelClassName, {
                    'visually-hidden': hideLabel,
                }), htmlFor: id, children: label })] }));
});
export default Switch;
